// Native Analytics — the shared anonymous view emitter (Spec 22). Plain TS, no
// React: callable from the app AND from Astro/marketing. Fire-and-forget; it
// must never throw into a page.

let analyticsUrl: string | null = null;

/**
 * Wire the emitter to this app's Supabase URL (confirm 3: an explicit init, not
 * a shared env read — the lib can't see either app's import.meta.env). Call once
 * at startup with the same PUBLIC_SUPABASE_URL the tracker uses.
 */
export function configureAnalytics(config: { url: string }): void {
  analyticsUrl = config.url;
}

/** Strip query + hash — return the pathname only. No PII rides in via ?… */
export function sanitizePath(pathname: string): string {
  return pathname.split(/[?#]/, 1)[0] ?? pathname;
}

/**
 * Fire an anonymous view beacon (Native Analytics lane 1). No Authorization
 * header, ever — anonymous ALWAYS, even for a signed-in app user (lane-1 views
 * carry no identity by design). `keepalive` lets it survive an unload. Any
 * failure is swallowed: analytics never breaks a page.
 */
export function trackView(input: {
  surface: 'app' | 'marketing';
  contentId?: string;
  path?: string;
}): void {
  if (!analyticsUrl) return;
  try {
    const body: Record<string, unknown> = { surface: input.surface };
    if (input.contentId) body.content_id = input.contentId;
    else if (input.path) body.path = sanitizePath(input.path);
    else return;
    void fetch(`${analyticsUrl}/functions/v1/track-view`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
      keepalive: true,
    }).catch(() => {});
  } catch {
    /* never throw into a page */
  }
}
